// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"48":"2a139db9","535":"e1c3d9d7","626":"8077200a","661":"194ffb92","713":"daefdb72","875":"74152d5c","878":"7b3961b9","966":"f6cdbe58"}[chunkId] + ".chunk.js";
};